/* global FEATURE_CART_STATIC_TOTALS */

// Third-party imports
import $ from 'jquery';

// Local imports
import * as addon_offer from './addon_offer.js';
import * as adjustment from './adjustment.js';
import * as checkout from './checkout.js';
import * as spsh_intro_letter from './spsh_intro_letter.js';
import * as total from './total.js';

// TODO: when the following flag is stabilized or removed, this should be
// converted to use ES6 module imports
const totals_box = FEATURE_CART_STATIC_TOTALS
    ? require('./static_totals.js')
    : require('./sticky_totals.js');

// --------------------------------------------------------------------------
// Module vars
// --------------------------------------------------------------------------
// Module name
export const MODULE_NAME = 'basket';

export let global_vars = {};

// --------------------------------------------------------------------------
// Functions
// --------------------------------------------------------------------------

// TODO: this should be run from the basket page entrypoint, not globally
export function initialize(global) {
    total.initialize(global);
    totals_box.initialize(global);
    adjustment.initialize(global);
    checkout.initialize(global);
    spsh_intro_letter.initialize(global);
    addon_offer.initialize(global);
    fromCardCustomization(global);

    // if (isBasketPage()) {
    //     total.initialize();
    //     sticky_totals.initialize(global);
    //     adjustment.initialize(global);
    //     checkout.initialize(global);
    //     spsh_intro_letter.initialize(global);
    //     addon_offer.initialize(global);

    //     fromCardCustomization(global);
    // }
}

// This method checks if we just came from the card customization page or not.
// If we came from the card customization page, we do a wait for document ready
// before submitting the #cart form.  This is to ensure that the loading of the
// sie_flag that occurs in sp-intro-letter.loadSieFlagCheck() takes place before
// we submit the form
//
// global arg is expected to be the window object when run in a browser
function fromCardCustomization(global) {
    let params;
    if (global.wv) {
        params = global.wv.url_params;
    }
    if (params && params.fromCardCustomization) {
        $(global.document).ready(() => {
            $('#cart').submit();
        });
    } else {
        // fromCardCustomization() - not from card customization
        $('.basket-loadingOverlay').addClass('basket-loadingOverlay--hidden');
    }
}

export function isBasketPage() {
    return $('body').hasClass('template-cart');
}
